import { useState, useEffect } from "react";

/**
 * Hook for managing bill change tracking and save states
 */
export const useBillChangeTracking = (bills: any[]) => {
  const [billsChanged, setBillsChanged] = useState(false);
  const [billsSnapshot, setBillsSnapshot] = useState(JSON.stringify(bills));
  const [isSaved, setIsSaved] = useState(false);

  // Track changes to bills
  useEffect(() => {
    const newSnapshot = JSON.stringify(bills);

    if (newSnapshot !== billsSnapshot) {
      setBillsChanged(true);
      setIsSaved(false);
    }
  }, [bills, billsSnapshot]);

  const markAsSaved = () => {
    setIsSaved(true);
    setBillsChanged(false);
    setBillsSnapshot(JSON.stringify(bills));
  };

  const updateSnapshot = (newBills: any[]) => {
    setBillsSnapshot(JSON.stringify(newBills));
  };

  return {
    billsChanged,
    isSaved,
    setBillsChanged,
    markAsSaved,
    updateSnapshot,
  };
};
